let config = {
  desktop: {
    colLeftStyle: {
      display: 'block',
      width: 200,
      fontSize: 13,
    },
    colRightStyle: {
      display: 'block',
      width: 150,
    },
    colMidStyle: {},
    toolBarTopStyle: {},
    drawAreaStyle: {
      height: '75vh',
    },
    drawAreaFooterStyle: {},
    userCommandInputStyle: {},
    modeContainerStyle: {},
    modeStyle: {
      fontSize: 11,
    },
    modeHeaderStyle: {
      padding: '1px 0px 1px 0px',
      fontSize: 12,
    },
    toolHeaderStyle: {
      padding: '1px 0px 1px 0px',
      fontSize: 12,
    },
    keyPadButtonStyle: {},
    enterButtonStyle: {},
    labelDisplay: 'inline-block',
  },
  tablet: {
    colLeftStyle: {
      display: 'block',
      width: 200,
      fontSize: 13,
    },
    colRightStyle: {
      display: 'block',
      width: 250,
    },
    colMidStyle: {},
    toolBarTopStyle: {},
    drawAreaStyle: {
      height: '75vh',
    },
    drawAreaFooterStyle: {},
    userCommandInputStyle: {},
    modeContainerStyle: {
      display: 'flex',
    },
    modeStyle: {
      width: '33%',
      textAlign: 'center',
      fontSize: 10,
    },
    modeHeaderStyle: {
      padding: '0px 0px 0px 0px',
      fontSize: 10,
    },
    toolHeaderStyle: {
      padding: '1px 0px 1px 0px',
      fontSize: 10,
    },
    keyPadButtonStyle: {
      height: 35,
    },
    enterButtonStyle: {
      fontSize: 16,
      padding: '5px 15px 5px 15px',
    },
    labelDisplay: 'none',
  },
  mobile: {
    colLeftStyle: {
      display: 'none',
      width: 150,
      fontSize: 10,
    },
    colRightStyle: {
      display: 'none',
      width: 200,
    },
    colMidStyle: {
      width: '100vh',
    },
    toolBarTopStyle: {
      display: 'none',
    },
    drawAreaStyle: {
      height: '80vh',
    },
    drawAreaFooterStyle: {
      height: '10vh',
    },
    userCommandInputStyle: {
      display: 'none',
    },
    modeContainerStyle: {},
    modeStyle: {},
    modeHeaderStyle: {},
    keyPadButtonStyle: {},
    enterButtonStyle: {},
    labelDisplay: 'none',
  },
  initialState: {
    entities: [
      {
        type: 'default',
        details: [],
      },
      {
        type: 'annotations',
        annotations: [],
      },
      {
        detailList: ['LA', 'GAR', 'OP', 'DECK', 'POOL', 'DETG'],
        detailLayers: [null, null, null, null, null, null],
        numLayers: 2,
      },
      {
        commandStartX: 100,
        commandStartY: 100,
        originX: null,
        originY: null,
      },
      {
        drawData: {
          lines: [],
        },
        standaloneDrawData: {
          lines: [],
        },
      },
    ],
    drawhistory: [
      [
        {
          type: 'default',
          details: [],
        },
        {
          type: 'annotations',
          annotations: [],
        },
        {
          detailList: ['LA', 'GAR', 'OP', 'DECK', 'POOL', 'DETG'],
          detailLayers: [null, null, null, null, null, null],
          numLayers: 2,
        },
        {
          commandStartX: 100,
          commandStartY: 100,
          originX: null,
          originY: null,
        },
        {
          drawData: {
            lines: [],
          },
          standaloneDrawData: {
            lines: [],
          },
        },
        {
          previewSettings: {
            mode: 'none',
            offset: 10,
          },
        },
      ],
    ],
    drawhistoryIndex: 0,
    saving: false,
    improvementID: null,
    dialogIsOpen: false,
    legacyCommandsConverted: false,
    open: true,
    loaded: false,
    print: false,
    previewOptions: false,
    previewSettings: { mode: 'none', offset: 10 },
    commandCloseError: false,
    commandCloseData: null,
    address: '',
    display: window.innerWidth < 750 ? 'mobile' : 'desktop',
    activeDetailIndex: 0,
    activeLayerIndex: 0,
    activePreviewLayerIndex: 0,
    sketchManagement: true,
    sketchDescription: '',
    sketchID: null,
    activePropertyIndex: 0,
    activePropertyInput: '',
    tool: 'angle',
    mode: null,
    tapMode: false,
    tapDown: false,
    commandInput: '',
    lastActionIndex: [0, 0],
    commandActive: false,
    commandTempDetail: null,
    selectedElement: null,
    propData: null,
    tempData: null,
    toolData: null,
    leftDragData: null,
    keyInput: { active: false, data: { degrees: '0', displayDegrees: '0' } },
    spacing: 10,
    windowWidth: 0,
    windowHeight: 0,
    offsetX: 0,
    offsetY: 0,
    scale: 1,
    windowX: 0,
    windowY: 0,
    startX: 0,
    startY: 0,
    redirect: true,
    saveSuccessful: false,
    targetX: 0,
    targetY: 0,
    commandStartX: 100,
    commandStartY: 100,
    highlightX: null,
    highlightY: null,
    mouseDown: false,
    mouse2Down: false,
    leftBound: 0,
    topBound: 0,
    scaleSessionX: 0,
    scaleSessionY: 0,
    activeScroll: false,
    autoZoom: true,
    precision: 0.5,
    textSettings: {
      labelColor: '#000000',
      labelSize: 13,
      annotationColor: '#000000',
      annotationSize: 13,
      dimensionColor: '#000000',
      dimensionSize: 13,
    },
    fullExtent: null,
    shift: false,
    grid: true,
    gridlines: true,
    background: {
      active: false,
      data: null,
      originX: 0,
      originY: 0,
      originSpacing: 10,
      initialWidth: 0,
      initialHeight: 0,
      degrees: 0,
      opacity: 100,
      windowWidth: 0,
      windowHeight: 0,
    },
    preview: false,
    legacyInput: false,
    follow: false,
    manual: false,
    manualInputActive: false,
    drawPortal: false,
    displayMarkup: true,
  },
};

module.exports = config;
